/* eslint-disable @typescript-eslint/no-unused-expressions */
import { progressApi } from "utilities/Axios";
import { getExtractedPath } from "utilities/extractedPath";

const extractedPath = getExtractedPath();

export const getAllEquipments = () => {
  return progressApi.get(`/TagMeta/GetAllEquipments${extractedPath}`);
};

export const getEquipmentsByUnitId = (unitId = 0) => {
  return progressApi.get(`/TagMeta/GetEquipmentsByUnitId${extractedPath}?id=${unitId}`);
};

export const createEquipment = (equipment: any) => {
  return progressApi.post(`/TagMeta/CreateEquipment${extractedPath}`, equipment);
};

export const updateEquipment = (equipment: any) => {
  return progressApi.post(`/TagMeta/UpdateEquipment${extractedPath}`, equipment);
};

export const deleteEquipment = (id: any) => {
  return progressApi.get(`/TagMeta/DeleteEquipment${extractedPath}?id=${id}`);
};
